module.exports = {
  language: '語言',
  selectLanguage: '選擇語言',
  charging: '充電中',
  notCharging: '未充電',
  advanceSetting: '進階設定',
  chargingDesc: '當電池電量低於 ',
  enabled: '已啟用',
  disabled: '已停用',
  onPowerRestore: '電源恢復時',
  powerWakeDesc: '** 請使用兩個獨立的 USB 充電器分別為樹莓派和 PiSugar 充電，並保持 PiSugar 的電源開關開啟。當外部電源恢復時，它將自動開機。',
  powerWakeDescFor3: 'PiSugar 將在外部電源恢復時自動開機。',
  powerWakeOffWarning: '您已關閉電源恢復喚醒功能，請不要單獨為樹莓派提供外部電源。',
  powerWakeOffTitle: '注意',
  confirmButtonText: '確認',
  wakeUpFeature: '定時喚醒',
  repeat: '重複',
  repeatEveryday: '每天重複。',
  repeatOn: '重複於',
  checkAll: '全選',
  clearAll: '全清',
  wakeUpDesc: '定時喚醒於',
  wakeUpOffDesc: '定時喚醒關閉。',
  buttonFunction: '自訂按鈕功能',
  singleTapLabel: '單擊',
  doubleTapLabel: '雙擊',
  longTapLabel: '長按',
  singleTap: '單擊',
  doubleTap: '雙擊',
  longTap: '長按',
  none: '無',
  edit: '編輯',
  customShell: '自訂指令',
  shutdown: '關機',
  shellModalTitle: {
    single: '單擊執行的指令',
    double: '雙擊執行的指令',
    long: '長按執行的指令'
  },
  shell: '指令',
  shellPlaceholder: '在此輸入腳本指令...',
  cancel: '取消',
  confirm: '確認',
  triggered: '已觸發',
  safeShutdown: '安全關機',
  batteryLevel: '電池電量',
  immediately: '立即',
  secondsDelay: '秒後延遲',
  rtcTime: 'RTC 時間',
  sysTime: '系統時間',
  syncTime: '同步時間',
  weekDay: {
    Monday: '週一',
    Tuesday: '週二',
    Wednesday: '週三',
    Thursday: '週四',
    Friday: '週五',
    Saturday: '週六',
    Sunday: '週日'
  },
  weekDayShort: {
    Mon: '週一',
    Tue: '週二',
    Wed: '週三',
    Thu: '週四',
    Fri: '週五',
    Sat: '週六',
    Sun: '週日'
  },
  batteryInputProtect: '電池輸入保護',
  batteryInputProtectDesc: '當電池達到 60% ~ 80% 時將停止充電過程，這可以有效延長電池壽命。',
  antiMistouch: '防誤觸',
  antiMistouchDesc: '開啟防誤觸功能後，需要點擊並按住開關才能觸發。',
  softPoweroff: '軟體關機',
  softPoweroffDesc: '使用開關按鈕關機時不會直接斷電，而是由軟體發出關機指令。',
  softPoweroffShell: '軟體關機指令',
  softPoweroffShellDesc: '觸發軟體關機事件時執行的指令。',
  changeLoginPassword: '修改登入密碼',
  username: '使用者名稱',
  password: '密碼',
  passwordConfirm: '請再次輸入密碼',
  usernameCannotBeEmpty: '使用者名稱不能為空',
  passwordCannotBeEmpty: '密碼不能為空',
  passwordNotConsistent: '兩次輸入的密碼必須一致',
  usernameWithSpace: '使用者名稱不能包含空格',
  passwordWithSpace: '密碼不能包含空格',
  changePasswordSuccess: '修改完成。',
  loginDialog: '登入',
  login: '登入'
}



// WEBPACK FOOTER //
// ./src/locale/zh-TW.js